import { render, staticRenderFns } from "./LastPage.vue?vue&type=template&id=b71672ca&scoped=true"
import script from "./LastPage.vue?vue&type=script&lang=js"
export * from "./LastPage.vue?vue&type=script&lang=js"
import style0 from "./LastPage.vue?vue&type=style&index=0&id=b71672ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71672ca",
  null
  
)

export default component.exports